import {
  SELECT_TASK_FORM_PROJECT,
  TOGGLE_ARCHIVE_PROJECT_FORM,
  TOGGLE_ARTICLE_CATEGORY_FORM,
  TOGGLE_ARTICLE_FORM,
  TOGGLE_ARTICLE_TAG_FORM,
  TOGGLE_CLIENT_INVITATION_FORM,
  TOGGLE_COMMENT_FORM_FOCUS,
  TOGGLE_DEPARTMENT_FORM,
  TOGGLE_EVENT_FORM,
  TOGGLE_EVENT_TYPE_FORM,
  TOGGLE_FREELANCER_FORM,
  TOGGLE_INVOICE_FORM,
  TOGGLE_LEGAL_ENTITY_FORM,
  TOGGLE_POSITION_FORM,
  TOGGLE_ROLE_FORM,
  TOGGLE_TASK_LABEL_FORM,
  TOGGLE_TIMER_FORM,
  TOGGLE_USER_CHANGE_PASSWORD_FORM,
  TOGGLE_USER_CLIENT_FORM,
  TOGGLE_USER_INVITE_FORM,
  TOGGLE_USER_ROLE_FORM,
  TOGGLE_TASK_MIGRATE_FORM,
  CLEAR_TASK_MIGRATE_FORM_DATASET,
  CLEAR_COMMENT_MIGRATE_FORM_DATASET,
  TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM,
  TOGGLE_COMMENT_MIGRATE_FORM,
  TOGGLE_TASK_SCHEDULE_FORM,
  TOGGLE_EVENT_SCHEDULE_FORM,
  TOGGLE_TASK_POPOVER_CONFIRM,
  // Dismiss user profile
  TOGGLE_DISMISS_PROFILE_FORM,
  LOAD_DISMISS_USER_PROJECTS_SUCCESS,
  LOAD_DISMISS_USER_SERVICES_SUCCESS,
  LOAD_DISMISS_USER_TASKS_SUCCESS,
} from 'constants/ActionTypes';

// Handles opening and closing of the user invite form
export const toggleUserInviteForm = (departmentId = null) => {
  return {
    type: TOGGLE_USER_INVITE_FORM,
    departmentId,
  };
};

// Handles opening and closing of the user role form
export const toggleUserRoleForm = (userId = null) => {
  return {
    type: TOGGLE_USER_ROLE_FORM,
    userId,
  };
};

// Handles opening and closing of the role form
export const toggleRoleForm = (roleId = null) => {
  return {
    type: TOGGLE_ROLE_FORM,
    roleId,
  };
};

// Handles opening and closing of the position form
export const togglePositionForm = (positionId = null) => {
  return {
    type: TOGGLE_POSITION_FORM,
    positionId,
  };
};

// Handles opening and closing of the freelancer form
export const toggleFreelancerForm = (freelancerId = null) => {
  return {
    type: TOGGLE_FREELANCER_FORM,
    freelancerId,
  };
};

// Handles opening and closing of the department form
export const toggleDepartmentForm = (departmentId = null) => {
  return {
    type: TOGGLE_DEPARTMENT_FORM,
    departmentId,
  };
};

// Handles opening and closing of the invoice form
export const togglePaymentForm = (invoiceId = null) => {
  return {
    type: TOGGLE_INVOICE_FORM,
    invoiceId,
  };
};

// Handles selecting of specified project in task form
export const selectTaskFormProject = (projectId = null) => {
  return {
    type: SELECT_TASK_FORM_PROJECT,
    projectId,
  };
};

// Handles opening and closing of the article form
export const toggleArticleForm = (articleId = null) => {
  return {
    type: TOGGLE_ARTICLE_FORM,
    articleId,
  };
};

// Handles opening and closing of the article category form
export const toggleArticleCategoryForm = (categoryId = null) => {
  return {
    type: TOGGLE_ARTICLE_CATEGORY_FORM,
    categoryId,
  };
};

// Handles opening and closing of the article tag form
export const toggleArticleTagForm = (tagId = null) => {
  return {
    type: TOGGLE_ARTICLE_TAG_FORM,
    tagId,
  };
};

// Handles opening and closing of the event form
export const toggleEventForm = (eventId = null, date = null) => {
  return {
    type: TOGGLE_EVENT_FORM,
    eventId,
    date,
  };
};

// Handles opening and closing of the event type form
export const toggleEventTypeForm = (typeId = null) => {
  return {
    type: TOGGLE_EVENT_TYPE_FORM,
    typeId,
  };
};

// Handles opening and closing of the clients form for archived project
export const toggleArchiveProjectForm = (projectId = null) => {
  return {
    type: TOGGLE_ARCHIVE_PROJECT_FORM,
    projectId,
  };
};

// Handles opening and closing of the client invitation form
export const toggleClientInvitationForm = (companyId = null, projectId = null, data = null) => {
  return {
    type: TOGGLE_CLIENT_INVITATION_FORM,
    companyId,
    projectId,
    data,
  };
};

// Handles opening and closing of the user timer form
export const toggleTimerForm = (taskId = null, data = null) => {
  return {
    type: TOGGLE_TIMER_FORM,
    taskId,
    data,
  };
};

// Handles opening and closing of the user client profile form
export const toggleUserClientForm = (userId = null) => {
  return {
    type: TOGGLE_USER_CLIENT_FORM,
    userId,
  };
};

// Handles opening and closing of the reset password form
export const toggleUserChangePasswordForm = () => {
  return {
    type: TOGGLE_USER_CHANGE_PASSWORD_FORM,
  };
};

// Handles opening and closing of the legal entity form
export const toggleLegalEntityForm = (
  entityId = null,
  relatedEntityId = null,
  relatedEntity = 'client',
  callback = null,
) => {
  return {
    type: TOGGLE_LEGAL_ENTITY_FORM,
    entityId,
    relatedEntityId,
    relatedEntity,
    callback,
  };
};

// Handler opening and closing of the task label/status form
export const toggleTaskLabelForm = (itemId = null, itemType = null, groupId = null) => {
  return {
    type: TOGGLE_TASK_LABEL_FORM,
    itemId,
    itemType,
    groupId,
  };
};

// Handles toggling of comment form focus
export const toggleCommentFormFocus = () => {
  return {
    type: TOGGLE_COMMENT_FORM_FOCUS,
  };
};

// Handles opening of task migrate form
export const toggleTaskMigrateForm = (taskId = null) => {
  return {
    type: TOGGLE_TASK_MIGRATE_FORM,
    taskId,
  };
};

// handle change project in migrate task form
export const clearTaskMigrateFormDataset = () => {
  return {
    type: CLEAR_TASK_MIGRATE_FORM_DATASET,
  };
};

// Handles opening and closing of the ProjectImportantPageForm form
export const toggleProjectImportantPageForm = (projectId = null) => {
  return {
    type: TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM,
    projectId,
  };
};

// Handlers opening of comment migrate form
export const toggleCommentMigrateForm = (payload = null) => {
  return {
    type: TOGGLE_COMMENT_MIGRATE_FORM,
    payload,
  };
};

// Handlers clear dataset in comment migrate form
export const clearCommentMigrateFormDataset = () => {
  return {
    type: CLEAR_COMMENT_MIGRATE_FORM_DATASET,
  };
};

// Handles opening and closing of the task schedule form
export const toggleTaskScheduleForm = (params = {}) => {
  return {
    type: TOGGLE_TASK_SCHEDULE_FORM,
    taskId: params.taskId,
    scheduleId: params.scheduleId,
  };
};

// Handles opening and closing of the task close/delete popover confirm
export const toggleTaskPopoverConfirm = (params = {}) => {
  return {
    type: TOGGLE_TASK_POPOVER_CONFIRM,
    taskId: params.taskId ?? null,
    action: params.action ?? null,
    beforeAction: params.beforeAction ?? null,
  };
};

// Handles opening and closing of the event schedule form
export const toggleEventScheduleForm = (params = {}) => {
  return {
    type: TOGGLE_EVENT_SCHEDULE_FORM,
    eventId: params.eventId,
    scheduleId: params.scheduleId,
    viewComponent: params.viewComponent,
  };
};

// DISMISS USER PROFILE FORM ACTIONS
// ---------------------------------

// Handles opening and closing of the dismiss profile form
export const toggleDismissProfileForm = (userId = null) => {
  return {
    type: TOGGLE_DISMISS_PROFILE_FORM,
    userId,
  };
};

// Success functions for update dataset for projects in DismissUserProfileForm
export const loadDismissUserProjectsSuccess = (response) => {
  return {
    type: LOAD_DISMISS_USER_PROJECTS_SUCCESS,
    primaryKey: 'projectId',
    response,
  };
};

// Success functions for update dataset for services in DismissUserProfileForm
export const loadDismissUserServicesSuccess = (response) => {
  return {
    type: LOAD_DISMISS_USER_SERVICES_SUCCESS,
    primaryKey: 'relationId',
    response,
  };
};

// Success functions for update dataset for tasks in DismissUserProfileForm
export const loadDismissUserTasksSuccess = (response) => {
  return {
    type: LOAD_DISMISS_USER_TASKS_SUCCESS,
    primaryKey: 'taskId',
    response,
  };
};
